import {
  ADD_COMPLAINT_QUESTION,
  ADD_COMPLAINT_QUESTION_FAIL,
  ADD_COMPLAINT_QUESTION_SUCCESS,
  ARRANGE_COMPLAINT_QUES_ORDER,
  ARRANGE_COMPLAINT_QUES_ORDER_FAIL,
  ARRANGE_COMPLAINT_QUES_ORDER_SUCCESS,
  DELETE_COMPLAINT_QUESTION,
  DELETE_COMPLAINT_QUESTION_FAIL,
  DELETE_COMPLAINT_QUESTION_SUCCESS,
  EDIT_COMPLAINT_QUESTION,
  EDIT_COMPLAINT_QUESTION_FAIL,
  EDIT_COMPLAINT_QUESTION_SUCCESS,
  GET_ADDED_COMPLAINT_QUESTION,
  GET_ADDED_COMPLAINT_QUESTION_FAIL,
  GET_ADDED_COMPLAINT_QUESTION_SUCCESS,
  GET_COMPLAINT_REGISTER,
  GET_COMPLAINT_REGISTER_FAIL,
  GET_COMPLAINT_REGISTER_SUCCESS,
  GET_COMPLAINT_FORM_PREVIEW,
  GET_COMPLAINT_FORM_PREVIEW_FAIL,
  GET_COMPLAINT_FORM_PREVIEW_SUCCESS,
  REVIEW_COMPAINT_FORM,
  REVIEW_COMPAINT_FORM_FAIL,
  REVIEW_COMPAINT_FORM_SUCCESS,
  GET_COMPLAINT_FORM,
  GET_COMPLAINT_FORM_FAIL,
  GET_COMPLAINT_FORM_SUCCESS,
} from "./actionTypes";

export const addComplaintQuestions = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_COMPLAINT_QUESTION,
  payload: { data, onSuccess, onError },
});

export const addComplaintQuestionSuccess = (data = {}) => ({
  type: ADD_COMPLAINT_QUESTION_SUCCESS,
  payload: data,
});

export const addComplaintQuestionError = (data = {}) => ({
  type: ADD_COMPLAINT_QUESTION_FAIL,
  payload: data,
});

export const getComplaintQuestions = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_ADDED_COMPLAINT_QUESTION,
  payload: { data, onSuccess, onError },
});
export const getComplaintQuestionSuccess = (data = {}) => ({
  type: GET_ADDED_COMPLAINT_QUESTION_SUCCESS,
  payload: data,
});
export const getComplaintQuestionError = (data = {}) => ({
  type: GET_ADDED_COMPLAINT_QUESTION_FAIL,
  payload: data,
});

export const deleteQuestion = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_COMPLAINT_QUESTION,
  payload: { data, onSuccess, onError },
});
export const deleteQuestionSuccess = (data = {}) => ({
  type: DELETE_COMPLAINT_QUESTION_SUCCESS,
  payload: data,
});
export const deleteQuestionError = (data = {}) => ({
  type: DELETE_COMPLAINT_QUESTION_FAIL,
  payload: data,
});

export const editComplaintQuestion = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: EDIT_COMPLAINT_QUESTION,
  payload: { data, onSuccess, onError },
});
export const editComplaintQuestionSuccess = (data = {}) => ({
  type: EDIT_COMPLAINT_QUESTION_SUCCESS,
  payload: data,
});
export const editComplaintQuestionError = (data = {}) => ({
  type: EDIT_COMPLAINT_QUESTION_FAIL,
  payload: data,
});

export const reaarangeComplaintQuestion = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ARRANGE_COMPLAINT_QUES_ORDER,
  payload: { data, onSuccess, onError },
});
export const reaarangeComplaintQuestionSuccess = (data = {}) => ({
  type: ARRANGE_COMPLAINT_QUES_ORDER_SUCCESS,
  payload: data,
});
export const reaarangeComplaintQuestionError = (data = {}) => ({
  type: ARRANGE_COMPLAINT_QUES_ORDER_FAIL,
  payload: data,
});

export const getComplaintRegister = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_COMPLAINT_REGISTER,
  payload: { data, onSuccess, onError },
});

export const getComplaintRegisterSuccess = (data = {}) => ({
  type: GET_COMPLAINT_REGISTER_SUCCESS,
  payload: data,
});
export const getComplaintRegisterError = (data = {}) => ({
  type: GET_COMPLAINT_REGISTER_FAIL,
  payload: data,
});

export const getComplaintFormDetail = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_COMPLAINT_FORM,
  payload: { data, onSuccess, onError },
});

export const getComplaintFormDetailSuccess = (data = {}) => ({
  type: GET_COMPLAINT_FORM_SUCCESS,
  payload: data,
});
export const getComplaintFormDetailError = (data = {}) => ({
  type: GET_COMPLAINT_FORM_FAIL,
  payload: data,
});
export const getComplaintPreview = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_COMPLAINT_FORM_PREVIEW,
  payload: { data, onSuccess, onError },
});
export const getComplaintPreviewSuccess = (data = {}) => ({
  type: GET_COMPLAINT_FORM_PREVIEW_SUCCESS,
  payload: data,
});
export const getComplaintPreviewError = (data = {}) => ({
  type: GET_COMPLAINT_FORM_PREVIEW_FAIL,
  payload: data,
});

export const submitComplaintFormReview = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: REVIEW_COMPAINT_FORM,
  payload: { data, onSuccess, onError },
});
export const submitComplaintFormReviewSuccess = (data = {}) => ({
  type: REVIEW_COMPAINT_FORM_SUCCESS,
  payload: data,
});
export const submitComplaintFormReviewError = (data = {}) => ({
  type: REVIEW_COMPAINT_FORM_FAIL,
  payload: data,
});
